import { calculateNewQueryParams } from 'src/store/modules/app/selectors';
import { useAppSelector } from 'src/utils/Hooks';
import { encodeHash } from 'src/utils/hashIds';

export const useBeaconHomeLink = () => {
  const retailer = useAppSelector((state) => state.retailer);
  const app = useAppSelector((state) => state.app);
  const allWeekIdsByRetailerId = useAppSelector((state) => state.allWeekIdsByRetailerId);
  const mainTimePeriod = useAppSelector((state) => state.mainTimePeriod);
  const comparisonTimePeriod = useAppSelector((state) => state.comparisonTimePeriod);
  const user = useAppSelector((state) => state.user);

  const beaconHomeLink = `/client/${user.config.vendor.hashId}${
    calculateNewQueryParams(
      app,
      { id: retailer.id === '0' ? Object.keys(allWeekIdsByRetailerId)[1] : retailer.id },
      mainTimePeriod,
      comparisonTimePeriod
    ).searchParams
  }&tab=${app.defaultQueryParams.tab}&subtab=${app.defaultQueryParams.subtab}`;

  return beaconHomeLink;
};

export const useAppHomeLink = () => {
  const isRestrictedDemoUser = useAppSelector((state) => state.user.config.isRestrictedDemoUser);
  const app = useAppSelector((state) => state.app);
  const retailer = useAppSelector((state) => state.retailer);
  const user = useAppSelector((state) => state.user);

  return {
    atlas: isRestrictedDemoUser
      ? `/home&tab=summary&subtab=atlas&entityType=category`
      : `/company/${encodeHash(0)}?rid=${retailer.id}`,
    advertising: `/overview&tab=${app.defaultQueryParams.tab}&subtab=${app.defaultQueryParams.subtab}`,
    omni: `/client/${user.config.vendor.BeaconClientId}`,
    beacon: ''
  };
};
